
import { defineComponent, PropType } from 'vue';
import FbxButton from '@/components/fbx-button.vue';
import VirtualRedTagHeader from '@/components/VirtualRedTag/VirtualRedTagHeader.vue';
import VirtualRedTagTrailerGraphic from '@/components/VirtualRedTag/VirtualRedTagTrailerGraphic.vue';
import virtualRedTagNotificationFlow from '@/shared/mixins/virtualRedTagNotificationFlow';
import { VirtualRedTagNotificationChannel } from '@/types/VirtualRedTagNotification';
import { VirtualRedTagTrailerGraphicState } from '@/types/VirtualRedTagTrailerGraphicState';

export default defineComponent({
    name: 'VirtualRedTagNotificationConfirmed',
    components: {
        FbxButton,
        VirtualRedTagHeader,
        VirtualRedTagTrailerGraphic,
    },
    mixins: [virtualRedTagNotificationFlow],
    props: {
        // From the save response; when true there is no "moved to Shop" message to
        // promise.
        trailerAlreadyInShop: {
            type: Boolean,
            default: false,
        },
        // Only used for the wording, so a missing or unknown value falls back to a
        // generic message rather than redirecting.
        method: {
            type: String as PropType<string | undefined>,
            default: undefined,
        },
    },
    computed: {
        GraphicState(): typeof VirtualRedTagTrailerGraphicState {
            return VirtualRedTagTrailerGraphicState;
        },
        subtitle(): string {
            if (this.trailerAlreadyInShop) {
                let channel = 'a message';
                if (this.method === VirtualRedTagNotificationChannel.email) {
                    channel = 'an email';
                } else if (
                    this.method === VirtualRedTagNotificationChannel.text
                ) {
                    channel = 'a text message';
                }
                return `This trailer is already in Shop. We'll send you ${channel} when repairs are completed and it is Available again.`;
            }
            let place = 'messages';
            if (this.method === VirtualRedTagNotificationChannel.email) {
                place = 'email';
            } else if (this.method === VirtualRedTagNotificationChannel.text) {
                place = 'texts';
            }
            return `Check your ${place} for updates on this trailer`;
        },
    },
});
